/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $GuardianAngels = {
    type: 'array',
    contains: {
        type: 'GuardianAngelResponse',
    },
};